import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Partners from './components/Partners';
import Services from './components/Services';
import SistemasERP from './components/SistemasERP';
import SitesIA from './components/SitesIA';
import RemoteSupport from './components/RemoteSupport';
import FAQ from './components/FAQ';
import About from './components/About';
import Clients from './components/Clients';
import BlingERP from './components/BlingERP';
import SHOficinaERP from './components/SHOficinaERP';
import DaniloContabilidadeBanner from './components/DaniloContabilidadeBanner';
import OnlineStore from './components/OnlineStore';
import Contact from './components/Contact';
import Footer from './components/Footer';
import SideMenu from './components/SideMenu';
import CookieConsent from './components/CookieConsent';
import PrivacyPolicy from './components/PrivacyPolicy';
import CookieSettingsButton from './components/CookieSettingsButton';
import AdminOrders from './components/AdminOrders';
import GoogleReview from './components/GoogleReview';
import GoogleMap from './components/GoogleMap';
import ComprarPage from './components/ComprarPage';
import Hospedagem from './components/Hospedagem';
import Intelbras from './components/Intelbras';
import Daten from './components/Daten';
import AssistenciaTecnica from './components/AssistenciaTecnica';
import OrcamentoIntelbras from './pages/OrcamentoIntelbras';
import AssistenciaTecnicaPage from './pages/AssistenciaTecnicaPage';
import DatenPage from './pages/DatenPage';
import ClientesVipPage from './pages/ClientesVipPage';
import WhatsAppChatWidget from './components/WhatsAppChatWidget';
import { Toaster } from './components/ui/toaster';
import { Toaster as SonnerToaster } from './components/ui/sonner';

function MainSite() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showCookieSettings, setShowCookieSettings] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);

  const handleResetCookieConsent = () => {
    localStorage.removeItem('fernando-tech-cookie-consent');
    setShowCookieSettings(true);
    window.location.reload();
  };

  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Partners />
      <Services />
      <SistemasERP />
      <SitesIA />
      <BlingERP />
      <SHOficinaERP />
      <DaniloContabilidadeBanner />
      <RemoteSupport />
      <FAQ />
      <About />
      <Clients />
      <OnlineStore />
      <Hospedagem />
      <Intelbras />
      <Daten />
      <AssistenciaTecnica />
      <Contact />
      <GoogleReview />
      <GoogleMap />
      <Footer 
        onOpenPrivacyPolicy={() => setShowPrivacyPolicy(true)} 
        onOpenAdmin={() => setShowAdmin(true)}
      />
      <SideMenu />
      <CookieConsent onOpenPrivacyPolicy={() => setShowPrivacyPolicy(true)} />
      <PrivacyPolicy isOpen={showPrivacyPolicy} onClose={() => setShowPrivacyPolicy(false)} />
      <CookieSettingsButton onClick={handleResetCookieConsent} />
      <AdminOrders isOpen={showAdmin} onClose={() => setShowAdmin(false)} />
      <Toaster />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/comprar" element={<ComprarPage />} />
        <Route path="/orcamento-intelbras" element={<OrcamentoIntelbras />} />
        <Route path="/assistencia-tecnica" element={<AssistenciaTecnicaPage />} />
        <Route path="/daten" element={<DatenPage />} />
        <Route path="/clientes-vip" element={<ClientesVipPage />} />
        <Route path="*" element={<MainSite />} />
      </Routes>
      {/* Widget de chat global — aparece em todas as páginas */}
      <WhatsAppChatWidget />
      {/* Toaster sonner para notificações de novos pedidos no admin */}
      <SonnerToaster position="top-right" richColors closeButton />
    </BrowserRouter>
  );
}

export default App;
